exports.baseURL = "https://admin.hikulive.com/";
exports.key = "p+lYJzn1dUaBDQytJk5DVehBAvhzJTSGmSJvcLh6kLo";